
import Component from 'vue-class-component'
import Vue from 'vue'

import MessageAlert from '@/components/MessageAlert.vue'
import UserEditor from '@/components/UserEditor.vue'
import { TextFieldRules } from '@/utils/enums'
import authModule from '@/store/auth'

@Component({
  name: 'LoginView',
  components: {
    MessageAlert,
    UserEditor
  }
})
class LoginView extends Vue {
  public isFormValid = false
  public showUserEditor = false
  public rules = TextFieldRules
  public form = {
    whitelabel: 'muensterland',
    email: '',
    password: ''
  }

  public get hasRouteParam() {
    return this.$route.params.wid && this.$route.params.wid.length > 0
  }

  public created(): void {
    if (this.hasRouteParam) {
      this.form.whitelabel = this.$route.params.wid
    }
  }

  public async login(): Promise<void> {
    await authModule.login(this.form)
    if (!authModule.user) return
    if (!authModule.user.firstName || !authModule.user!.lastName) {
      this.showUserEditor = true
    } else {
      this.routeToHome()
    }
  }

  public routeToHome(): void {
    if (authModule.isPartner) {
      this.$router.replace({ name: 'AllDeals' })
    } else if (authModule.isLightPartner) {
      this.$router.replace({ name: 'ScanCode' })
    } else {
      this.$router.replace({ name: 'Home' })
    }
  }

  get isFindooDomain() {
    return window.location.hostname.includes('findoo')
  }
}

export default LoginView
